"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

exports.Box = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  max-height: ", ";\n  width: ", ";\n  max-width: ", ";\n  padding: ", ";\n  margin: ", ";\n  display: ", ";\n  flex: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  text-align: ", ";\n"])), function (props) {
  var _a;

  return (_a = props.height) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.maxHeight) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.width) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.maxWidth) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.padding) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.margin) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.display) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.flex) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.flexDirection) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.flexGrow) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.flexShrink) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.justifyContent) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.alignItems) !== null && _a !== void 0 ? _a : "";
}, function (props) {
  var _a;

  return (_a = props.textAlign) !== null && _a !== void 0 ? _a : "";
});